<!-- @format -->

<div
	class="availability hmf-display-flex hmf-flex-column hmf-justify-content-center"
	[class]="showStoreNameInMessage() ? 'no-explicit-height' : ''">
	@if (productAvailabilityData() && !isComingSoon() && !isOOS()) {
		<div class="shipping-availability hmf-display-flex hmf-flex-row hmf-pb-xxxs hmf-align-items-center"
			[class.standard-typography]="!showStoreNameInMessage()"
			[class.storename-typography]="showStoreNameInMessage()">
			<homefield-icon
				class="hmf-display-inline-block hmf-mr-xxxs"
				height="10px"
				width="10px"
				[class]="shippingMessage()?.class"
				[name]="shippingMessage()?.icon ?? ''">
			</homefield-icon>
			<span class="hmf-display-inline-block"> {{ shippingMessage()?.text ?? '' }}</span>
		</div>
	}
	@if (selectedStoreName() && !isComingSoon() && !isOOS()) {
		<div class="store-availability hmf-display-flex hmf-flex-row hmf-pb-xxxs hmf-align-items-center"
			[class.standard-typography]="!showStoreNameInMessage()"
			[class.storename-typography]="showStoreNameInMessage()">
			<homefield-icon
				class="hmf-display-inline-block hmf-mr-xxxs"
				height="10px"
				width="10px"
				[class]="pickupMessage()?.class"
				[name]="pickupMessage()?.icon ?? ''">
			</homefield-icon>
			@if (showStoreNameInMessage()) {
				<div class="hmf-display-inline-block">
					<span> {{ pickupMessage()?.text ? pickupMessage()?.text + ' at ' : '' }}</span>
					<button
						hmf-action-text
						size="small"
						variant="secondary"
						[attr.aria-label]="pickupMessage()?.text ? `${ pickupMessage()?.text } at ${ selectedStoreName() | titlecase }. Update My Store` : null"
						(click)="clickSelectedStoreName.emit()">
						{{ selectedStoreName() | titlecase }}
					</button>
				</div>
			} @else {
				<span class="hmf-display-inline-block"> {{ pickupMessage()?.text ?? '' }}</span>
			}
		</div>
	}
</div>
